export default {
  ApplicationInfo: '申請資訊',
  Game: '遊戲',
  Account: '帳號',
  Server: '伺服器',
  CharacterName: '角色名',
  PlatformOrderNumber: '平台訂單編號',
  Amount: '金額',
  InvoiceMethod: '開立發票方式',
  InvoiceByTotalOrderAmount: '依訂單總額開立發票',
  InvoiceByOrderAmountSeparately: '依訂單金額，分別開立發票',
  PhoneNumber: '聯絡電話',
  Name: '姓名',
  Address: '地址',
  InvoiceTitle: '發票抬頭',
  PersonalTitleOnlyNoCompany: '僅支援個人抬頭，不支援公司抬頭',
  ReceivingEmail: '接收信箱',
  Remarks: '備註',
  InputContent: '輸入內容',
  ApplicationSubmittedSuccessfully: '申請提交成功',
  InvoiceApplicationSubmittedSuccessfully:
    '您的發票申請已提交成功\r\n工作人員將在7個工作天內處理，請注意查收郵件',
  Confirm: '確定',
  Submit: '提交',
  ApplicationSubmissionFailed: '申請提交失敗',
  InvoiceApplicationFailed:
    '您的發票申請提交失敗。請重新整理再試一次或聯絡客服',
  InvoiceApplicationSubmitted: '您的發票申請已提交，請勿重複提交',
  PleaseEnterName: '請輸入姓名',
  PleaseEnterAddress: '請輸入地址',
  PleaseEnterInvoiceTitle: '請輸入發票抬頭',
  PleaseEnterEmail: '請輸入接收信箱',
  PleaseEnterRemarks: '請輸入備註資訊',
  NumberParsingError: '號碼解析錯誤',
  PleaseEnterValidEmailFormat: '請輸入有效的電子郵件格式',
  IncompleteInformation: '資訊不完整，請檢查',
  ExpandAll: '展開全部'
};
